import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { TimeEntryDto } from '@cw/shared';
import { api } from './api';
import { handleFormError } from './forms';
import { useCan } from './session';

export const timeKeys = {
  all: ['time'] as const,
  running: ['time', 'running'] as const,
  list: (qs: string) => ['time', 'list', qs] as const,
};

export function useRunningTimer() {
  return useQuery({
    queryKey: timeKeys.running,
    queryFn: () => api.get<TimeEntryDto | null>('/time/running'),
    enabled: useCan('time:track'),
    staleTime: 30_000,
  });
}

export function useTimeEntries(f: {
  from?: string;
  to?: string;
  userId?: string;
  projectId?: string;
  taskId?: string;
}) {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(f)) if (v) p.set(k, v);
  const qs = p.toString();
  return useQuery({ queryKey: timeKeys.list(qs), queryFn: () => api.get<TimeEntryDto[]>(`/time?${qs}`) });
}

/** Ligar/desligar o timer de qualquer lugar (barra superior, tarefa, página de horas). */
export function useTimerActions() {
  const qc = useQueryClient();
  const refresh = () => {
    void qc.invalidateQueries({ queryKey: ['projects', 'client-board'] });
    return qc.invalidateQueries({ queryKey: timeKeys.all });
  };
  const start = useMutation({
    mutationFn: (b: {
      taskId?: string | null;
      taskItemId?: string | null;
      projectId?: string | null;
      description?: string;
    }) => api.post<TimeEntryDto>('/time/start', b),
    onSuccess: () => {
      void refresh();
      toast.success('Timer ligado');
    },
    onError: (e) => handleFormError(e),
  });
  const stop = useMutation({
    mutationFn: () => api.post<TimeEntryDto>('/time/stop'),
    onSuccess: () => void refresh(),
    onError: (e) => handleFormError(e),
  });
  return { start, stop };
}
